/*
 * File: c:\Users\j.mazat\Desktop\Autofi\autofi_backoffice\src\Content\Equipment\Equipment.tsx
 * Project: c:\Users\j.mazat\Desktop\Autofi\autofi_backoffice
 * Created Date: Tuesday March 26th 2024
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Tuesday March 26th 2024 11:02:35 am
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2024 Autobuy SAS
 * -----
 */

import Styles from "Content/Equipment/Equipment.module.css";
import { UpdateCarType } from "Type/CarElement.type.hold";
import { CarEquipmentType } from "Type/singleCarDbType";
import { useEffect, useRef, useState } from "react";
import { FaCheckCircle } from "react-icons/fa";
import { RxCrossCircled } from "react-icons/rx";

type EquipmentProps = {
    equipment: CarEquipmentType;
    handleDelete: Function;
    handleValid: Function;
    handleUpdate: Function;
    customClass?: string;
    disabled: boolean;
};

export function Equipment(props: EquipmentProps) {
    const [input, setInput] = useState(props.equipment.Name);
    const firsload = useRef(true);
    useEffect(() => {
        if (!firsload.current && input !== props.equipment.Name)
            props.handleUpdate(input);
        else
            firsload.current = false;
    }, [input]);

    const resetAsValid = () => {
        props.handleValid(input);
        if (!input)
            setInput(props.equipment.Name);
    };

    return (
        <li key={props.equipment.id} className={`${props.customClass ?? ""} ${Styles.equipment}`}>
            {
                !props.equipment.toDelete && props.disabled ?
                <RxCrossCircled className={`${Styles.icon} ${Styles.close}`} height={"2rem"} width={"2rem"} onClick={() => props.handleDelete()}/>
                : (
                    props.equipment.toDelete ?
                    <FaCheckCircle className={`${Styles.icon} ${Styles.valid}`} height={"2rem"} width={"2rem"} onClick={resetAsValid}/>
                    :null
                )
            }
            <input disabled={props.equipment.toDelete || !props.disabled} className={`${Styles.myInputStyle} ${!props.equipment.isNew && props.equipment.toDelete ? Styles.deleteEquipment : "" }`} type="text" value={input} onBlur={(e) => e.target.value == "" ? props.handleDelete() : {}} onChange={(e) => setInput(e.target.value)} />
        </li>
    );
};
